import { render } from "./modal_listedesarticles.vue?vue&type=template&id=f9392802&scoped=true"
import script from "./modal_listedesarticles.vue?vue&type=script&lang=js"
export * from "./modal_listedesarticles.vue?vue&type=script&lang=js"

import "./modal_listedesarticles.vue?vue&type=style&index=0&id=f9392802&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9392802"]])

export default __exports__